'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initializeOpenAiAds, trackOpenAiPage } from '@/lib/analytics/openai-ads';

export default function OpenAiAdsPixel() {
  const pathname = usePathname();
  useEffect(() => {
    initializeOpenAiAds();
    trackOpenAiPage(pathname);
  }, [pathname]);
  return null;
}
